import React from 'react'
import {
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
    Tooltip,
} from '@diversioteam/diversio-ds'

import { useCopyToClipboard } from 'hooks/useCopyToClipboard'
import img from 'assets/images/pulseSurveys/people-dialog.svg'

import * as S from './../dialog.styles'

export const PeopleDialog = (props: DialogProps) => {
    const { isCopied, copyToClipboard } = useCopyToClipboard()

    const handleClose = () => {
        if (props.onClose) {
            props.onClose({}, 'backdropClick')
        }
    }

    return (
        <S.DialogWrapper hideBackdrop={false} {...props}>
            <DialogTitle>
                <img src={img} alt="" />
                People・Survey
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <p>Capture a clear picture of your team’s diversity across key identity groups.</p>

                    <p>Why it matters:</p>
                    <ul>
                        <li>Understand who makes up your workforce</li>
                        <li>Spot representation gaps</li>
                        <li>Set informed DEI goals backed by data</li>
                    </ul>

                    <p>
                        This survey is the foundation for all culture assessments.
                        <br />
                        <strong>Contact us or reach out directly to your CSM to get started.</strong>
                    </p>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button color="secondaryLight" onClick={handleClose} fullWidth>
                    Cancel
                </Button>

                <Tooltip
                    title="Copied!"
                    variant="light"
                    size="medium"
                    open={isCopied}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                >
                    <Button onClick={() => copyToClipboard('hello@diversio.com')} fullWidth>
                        Copy: hello@diversio.com
                    </Button>
                </Tooltip>
            </DialogActions>
        </S.DialogWrapper>
    )
}
